/* global axios */

import ApiClient from './ApiClient';

class IntegrationsAPI extends ApiClient {
  constructor() {
    super('integrations/apps', { accountScoped: true });
  }

  connectSlack(code) {
    return axios.post(`${this.baseUrl()}/integrations/slack`, { code });
  }

  updateSlack({ referenceId }) {
    return axios.patch(`${this.baseUrl()}/integrations/slack`, {
      reference_id: referenceId,
    });
  }

  listAllSlackChannels() {
    return axios.get(`${this.baseUrl()}/integrations/slack/list_all_channels`);
  }

  delete(integrationId) {
    return axios.delete(`${this.baseUrl()}/integrations/${integrationId}`);
  }

  createHook(hookData) {
    return axios.post(`${this.baseUrl()}/integrations/hooks`, hookData);
  }

  deleteHook(hookId) {
    return axios.delete(`${this.baseUrl()}/integrations/hooks/${hookId}`);
  }

  connectShopify({ shopDomain }) {
    return axios.post(`${this.baseUrl()}/integrations/shopify/auth`, {
      shop_domain: shopDomain,
    });
  }

  connectExternalNotifications(settings) {
    return axios.post(`${this.baseUrl()}/integrations/hooks`, {
      app_id: 'external_notifications',
      settings,
    });
  }

  updateExternalNotificationsSettings(hookId, settings) {
    return axios.patch(`${this.baseUrl()}/integrations/hooks/${hookId}`, {
      settings,
    });
  }

  showHook(hookId) {
    return axios.get(`${this.baseUrl()}/integrations/hooks/${hookId}`);
  }

  connectAkiles({ code, clientId, clientSecret, redirectUri }) {
    return axios.post(`${this.baseUrl()}/integrations/akiles`, {
      code,
      client_id: clientId,
      client_secret: clientSecret,
      redirect_uri: redirectUri,
    });
  }

  updateAkilesSettings({ whatsappInboxId, bookingTemplateName, checkinTemplateName }) {
    return axios.patch(`${this.baseUrl()}/integrations/akiles`, {
      whatsapp_inbox_id: whatsappInboxId,
      booking_template_name: bookingTemplateName,
      checkin_template_name: checkinTemplateName,
    });
  }

  disconnectAkiles() {
    return axios.delete(`${this.baseUrl()}/integrations/akiles`);
  }
}

export default new IntegrationsAPI();
